import React from 'react';

interface FloatingActionButtonProps {
  onClick: () => void;
  icon: string;
  label?: string;
  color?: string;
  className?: string;
}

export const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ 
  onClick, 
  icon, 
  label, 
  color = 'bg-foret-600',
  className = ''
}) => {
  return (
    <button
      onClick={onClick}
      className={`md:hidden fixed bottom-20 right-6 w-14 h-14 ${color} text-white rounded-full shadow-2xl flex items-center justify-center z-[101] transition-all active:scale-90 animate-in fade-in zoom-in duration-300 ${className}`}
      title={label}
    >
      <i className={`${icon} text-2xl`} />
      {/* Optionnel: un petit badge textuel si besoin */}
      {/* {label && <span className="sr-only">{label}</span>} */}
    </button>
  );
};
